export default __webpack_public_path__ + "static/media/shape.27500d73.png";